import React, { useEffect } from 'react';
import { AuthenticationCheck } from '@jira/spa-apps__common/src/AuthenticationCheck.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import type IssueCreateEmbed from '@jira/issue-create__issue-create-embed/src/ui/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { issueCreateEmbedRoute } from '@jira/router-routes__issue-create-embed-routes/src/issueCreateEmbedRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const handleEmbedLinkClick = (e: Event) => {
	const eventTarget: EventTarget | null = e.target;
	// this is used for handling all the button clicks inside the iframe to open the new link in a new tab
	// as this view is mainly used an embed view inside an iframe.
	if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') {
		// link
		eventTarget.target = '_blank';
	}
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyIssueCreateEmbed = lazyForPaint<typeof IssueCreateEmbed>(
	() =>
		import(
			/* webpackChunkName: "async-issue-create-embed", jiraSpaEntry: "async-issue-create-embed" */ '@jira/issue-create__issue-create-embed/src/index.tsx'
		),
	{ ssr: false },
);
const IssueCreateEmbedLazy = () => {
	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.addEventListener('click', handleEmbedLinkClick, true);
		return () => {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.removeEventListener('click', handleEmbedLinkClick);
		};
	}, []);
	return (
		<AuthenticationCheck>
			<LazyPage
				Page={LazyIssueCreateEmbed}
				pageId="spa-apps/issue-create-embed"
				shouldShowSpinner
			/>
		</AuthenticationCheck>
	);
};
export const issueCreateEmbedRouteEntry: Route = createEntry(issueCreateEmbedRoute, () => ({
	group: 'issue',
	// eslint-disable-next-line no-restricted-syntax
	component: IssueCreateEmbedLazy,
	resources: [...jiraSpaResources()],
	layout: chromelessLayout,
	forPaint: [LazyIssueCreateEmbed],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
